import { PATHS } from '@/routes/paths'
import { GLOBAL_DEFAULT_SEO } from '../defaults'
import { absoluteUrl } from '../utils'
import { organizationSchema, websiteSchema, localBusinessSchema } from '../schemas/common'

export function buildHomeSeo() {
  return {
    ...GLOBAL_DEFAULT_SEO,
    canonical: absoluteUrl(PATHS.home),
    schema: [organizationSchema(), localBusinessSchema(), websiteSchema()],
  }
}
